module.exports = __webpack_public_path__ + "media/images/design/common/images/footer_name-5968897b57430fd3dcdae31f2fe0de99.png";